import React from "react";
import ReactDOM from "react-dom";

import Book from "./Book";

import "./index.css";

import { books } from "./data/books";

const BookList = () => {
  return (
    <section className="booklist">
      {books.map((book) => {
        return <Book key={book.id} {...book} />;
      })}
    </section>
  );
};

ReactDOM.render(<BookList />, document.getElementById("root"));
